import { render, staticRenderFns } from "./ganntChart.vue?vue&type=template&id=74ec342a&scoped=true"
import script from "./ganntChart.vue?vue&type=script&lang=js"
export * from "./ganntChart.vue?vue&type=script&lang=js"
import style0 from "./ganntChart.vue?vue&type=style&index=0&id=74ec342a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ec342a",
  null
  
)

export default component.exports